import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useData } from '../context/DataContext';

const Footer: React.FC = () => {
  const { categories } = useData();
  
  // Get active categories sorted by display order
  const activeCategories = categories
    .filter(c => c.active !== false)
    .sort((a, b) => {
      if (a.displayOrder !== undefined && b.displayOrder !== undefined) {
        return a.displayOrder - b.displayOrder;
      }
      if (a.displayOrder !== undefined) return -1;
      if (b.displayOrder !== undefined) return 1;
      return a.name.localeCompare(b.name);
    })
    .slice(0, 6); // Show up to 6 categories in footer

  return (
    <footer className="bg-keystone-blue text-white py-8 mt-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <span>(267) 718-3596</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <span>info@keystoneprinter.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4" />
                <span>24 Green Street, Lansdale, PA 19446</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Categories</h3>
            <ul className="space-y-2">
              {activeCategories.length > 0 ? (
                activeCategories.map(category => (
                  <li key={category.id}>
                    <Link 
                      to={`/products?category=${encodeURIComponent(category.name)}`}
                      className="hover:text-keystone-gold transition-colors"
                    >
                      {category.name}
                    </Link>
                  </li>
                ))
              ) : (
                <li className="text-gray-300">No categories available</li>
              )}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Business Hours</h3>
            <div className="space-y-1">
              <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
              <p>Saturday: Closed</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p>&copy; 2024 Keystone Sign Printing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;